import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiktok = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4910_545)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.0725 0.5H13.0278V16.8478C13.0278 18.7957 11.4722 20.3957 9.53626 20.3957C7.60034 20.3957 6.04469 18.7957 6.04469 16.8478C6.04469 14.9348 7.56577 13.3695 9.43257 13.3V9.19567C5.31872 9.2652 2 12.6391 2 16.8478C2 21.0913 5.38786 24.5 9.57085 24.5C13.7538 24.5 17.1416 21.0565 17.1416 16.8478V8.4652C18.6627 9.57827 20.5295 10.2391 22.5 10.2739V6.16957C19.4579 6.06522 17.0725 3.56087 17.0725 0.5Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4910_545",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgTiktok;
